export const GATES = {
  INBOX_NAVIGATION: 'CustomerPortal::InboxNavigation::FE',
  CONFIGURED_TICKET_DETAIL_PROPERTIES: 'CustomerPortal:ConfiguredTicketDetailProperties',
  ADVANCED_SEARCH: 'SupportSpace:AdvancedSearch:FE'
};